import styled from "styled-components";

type PlayPauseButtonProps = {
  isPlaying: boolean;
  onClick: () => void;
};

const ButtonContainer = styled.button`
  position: absolute;
  bottom: 20px;
  left: 20px;
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  cursor: pointer;
  z-index: 100;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

const PlayPauseButton = ({ isPlaying, onClick }: PlayPauseButtonProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick();
  };

  const pauseSvg = (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="14" fill="white"></circle>
      <rect x="10" y="10" width="3" height="8" fill="black"></rect>
      <rect x="15" y="10" width="3" height="8" fill="black"></rect>
    </svg>
  );

  const playSvg = (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="14" cy="14" r="14" fill="white"></circle>
      <path
        d="M10.8387 18.3654V10.2363L18.9678 14.4514L10.8387 18.3654Z"
        fill="black"
        stroke="black"
        strokeWidth="0.301075"
      ></path>
    </svg>
  );

  return (
    <ButtonContainer onClick={handleClick}>
      {isPlaying ? pauseSvg : playSvg}
    </ButtonContainer>
  );
};

export { PlayPauseButton };
